// extracted by mini-css-extract-plugin
export default {"form":"InputButton_form__ow57z"};